var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Model, { attr } from '@ember-data/model';
export let FailureCode = /*#__PURE__*/function (FailureCode) {
  FailureCode["DUPLICATE_LOCATION_ID"] = "DUPLICATE_LOCATION_ID";
  FailureCode["DOORDASH_DRIVE_STORE"] = "DOORDASH_DRIVE_STORE";
  FailureCode["SFDC_ACCOUNT_RECORD_NOT_FOUND"] = "SFDC_ACCOUNT_RECORD_NOT_FOUND";
  FailureCode["MENU_PULLING_REQUEST_FAILURE"] = "MENU_PULLING_REQUEST_FAILURE";
  FailureCode["STORE_HOURS_NOT_POPULATED_FAILURE"] = "STORE_HOURS_NOT_POPULATED_FAILURE";
  FailureCode["MENU_JOB_FAILURE"] = "MENU_JOB_FAILURE";
  FailureCode["MENU_BLANK_FAILURE"] = "MENU_BLANK_FAILURE";
  FailureCode["EXISTING_IN_PROGRESS_ONBOARDING"] = "EXISTING_IN_PROGRESS_ONBOARDING";
  FailureCode["SYSTEM_ERROR"] = "SYSTEM_ERROR";
  return FailureCode;
}({});
const RetryableFailureCodes = new Set([FailureCode.EXISTING_IN_PROGRESS_ONBOARDING, FailureCode.SFDC_ACCOUNT_RECORD_NOT_FOUND, FailureCode.MENU_PULLING_REQUEST_FAILURE, FailureCode.STORE_HOURS_NOT_POPULATED_FAILURE, FailureCode.MENU_JOB_FAILURE, FailureCode.MENU_BLANK_FAILURE]);
export const FailureCodeToI18NString = {
  [FailureCode.EXISTING_IN_PROGRESS_ONBOARDING]: 'onlineChannels.doordash.menuConfiguration.failureExistingInProgressOnboarding',
  [FailureCode.DUPLICATE_LOCATION_ID]: 'onlineChannels.doordash.menuConfiguration.failureDuplicateLocation',
  [FailureCode.DOORDASH_DRIVE_STORE]: 'onlineChannels.doordash.menuConfiguration.failureDoorDashDriveStore',
  [FailureCode.SFDC_ACCOUNT_RECORD_NOT_FOUND]: 'onlineChannels.doordash.menuConfiguration.failureDoorDashSfdcRecordNotFound',
  [FailureCode.MENU_PULLING_REQUEST_FAILURE]: 'onlineChannels.doordash.menuConfiguration.failureDoorDashMenuPullingRequestFailure',
  [FailureCode.STORE_HOURS_NOT_POPULATED_FAILURE]: 'onlineChannels.doordash.menuConfiguration.failureDoorDashStoreHoursNotPopulatedFailure',
  [FailureCode.MENU_JOB_FAILURE]: 'onlineChannels.doordash.menuConfiguration.failureDoorDashMenuJobFailure',
  [FailureCode.MENU_BLANK_FAILURE]: 'onlineChannels.doordash.menuConfiguration.failureDoorDashMenuBlankFailure',
  [FailureCode.SYSTEM_ERROR]: 'onlineChannels.doordash.menuConfiguration.failureUnknown'
};
const systemErrorMappings = [{
  error: 'Store is configured as a Retail merchant and is currently unable to be activated',
  translation: 'onlineChannels.doordash.menuConfiguration.failureDoorDashRetailStore'
}];
export let State = /*#__PURE__*/function (State) {
  State["INITIALIZING"] = "INITIALIZING";
  State["INITIALIZED"] = "INITIALIZED";
  State["PENDING"] = "PENDING";
  State["ACTIVE"] = "ACTIVE";
  State["FAILED"] = "FAILED";
  State["APPROVED"] = "APPROVED";
  State["DISABLED"] = "DISABLED";
  return State;
}({});
export let StoreStatusChangeReason = /*#__PURE__*/function (StoreStatusChangeReason) {
  StoreStatusChangeReason["STORE_SELF_DISABLED_IN_THEIR_POS_PORTAL"] = "STORE_SELF_DISABLED_IN_THEIR_POS_PORTAL";
  StoreStatusChangeReason["DELETE_STORE"] = "DELETE_STORE";
  return StoreStatusChangeReason;
}({});
export let IntegrationType = /*#__PURE__*/function (IntegrationType) {
  IntegrationType["DOORDASH"] = "DOORDASH";
  IntegrationType["UBEREATS"] = "UBEREATS";
  return IntegrationType;
}({});
let MenuConfiguration = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('string'), _dec4 = attr('string'), _dec5 = attr('string'), _dec6 = attr('number'), _dec7 = attr('string'), _dec8 = attr('number'), _dec9 = attr('string'), _dec10 = attr('boolean'), _dec11 = attr('string'), _dec12 = attr('string'), _dec13 = attr('string'), _dec14 = attr('date'), _dec15 = attr('date'), _dec16 = attr('number'), _dec17 = attr('string'), _class = class MenuConfiguration extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "integrationType", _descriptor, this);
    _initializerDefineProperty(this, "integrationId", _descriptor2, this);
    _initializerDefineProperty(this, "integrationPrimitiveId", _descriptor3, this);
    _initializerDefineProperty(this, "locationPrimitiveId", _descriptor4, this);
    _initializerDefineProperty(this, "locationId", _descriptor5, this);
    _initializerDefineProperty(this, "priceInflation", _descriptor6, this);
    _initializerDefineProperty(this, "priceRoundingMode", _descriptor7, this);
    _initializerDefineProperty(this, "pickupPriceInflation", _descriptor8, this);
    _initializerDefineProperty(this, "pickupPriceRoundingMode", _descriptor9, this);
    _initializerDefineProperty(this, "modifierInflation", _descriptor10, this);
    _initializerDefineProperty(this, "failureCode", _descriptor11, this);
    _initializerDefineProperty(this, "failureReason", _descriptor12, this);
    _initializerDefineProperty(this, "state", _descriptor13, this);
    _initializerDefineProperty(this, "createdAt", _descriptor14, this);
    _initializerDefineProperty(this, "updatedAt", _descriptor15, this);
    _initializerDefineProperty(this, "defaultPrepTime", _descriptor16, this);
    _initializerDefineProperty(this, "pickupInstructions", _descriptor17, this);
  }
  get isInitializing() {
    return this.state === State.INITIALIZING;
  }
  get isInitialized() {
    return this.state === State.INITIALIZED;
  }
  get isPending() {
    return this.state === State.PENDING;
  }

  // The disabled state is the backend state for when a seller pauses their integration
  // for this specific menu configuration. In the UI, we represent this as "Paused"
  get isDisabled() {
    return this.state === State.DISABLED;
  }
  get isActive() {
    return this.state === State.ACTIVE;
  }
  get isApproved() {
    return this.state === State.APPROVED;
  }
  get isFailed() {
    return this.state === State.FAILED;
  }
  get variantType() {
    switch (true) {
      case this.isInitializing:
        return 'warning';
      case this.isInitialized:
        return 'normal';
      case this.isActive:
        return 'success';
      case this.isDisabled:
        return 'emphasis';
      case this.isPending:
        return 'emphasis';
      default:
        return 'normal';
    }
  }
  get isOnboarding() {
    return [State.INITIALIZING, State.INITIALIZED, State.PENDING, State.APPROVED, State.FAILED].includes(this.state);
  }
  get isRetryableFailure() {
    return RetryableFailureCodes.has(this.failureCode);
  }
  get isRetryableStoreOnboardingFailure() {
    return [FailureCode.EXISTING_IN_PROGRESS_ONBOARDING, FailureCode.SFDC_ACCOUNT_RECORD_NOT_FOUND].includes(this.failureCode);
  }
  get failureTranslationString() {
    if (this.failureCode === FailureCode.SYSTEM_ERROR) {
      const existingSystemErrorMapping = systemErrorMappings.find(mapping => this.failureReason.includes(mapping.error));
      if (existingSystemErrorMapping) {
        return existingSystemErrorMapping.translation;
      }
    }
    const failureCodeFromMap = FailureCodeToI18NString[this.failureCode];
    if (failureCodeFromMap) {
      return failureCodeFromMap;
    }
    return 'onlineChannels.doordash.menuConfiguration.failureUnknown';
  }
  get translationString() {
    switch (true) {
      case this.isInitializing:
        return 'onlineChannels.doordash.common.state.initializing';
      case this.isInitialized:
        return 'onlineChannels.doordash.common.state.initialized';
      case this.isActive:
        return 'onlineChannels.doordash.common.state.active';
      case this.isDisabled:
        return 'onlineChannels.doordash.common.state.paused';
      case this.isPending:
        return 'onlineChannels.doordash.common.state.pending';
      default:
        return 'onlineChannels.doordash.common.state.active';
    }
  }
  async initialize() {
    if (!this.isInitializing) {
      return;
    }
    const adapter = this.store.adapterFor('menu-sync/menu-configuration');
    await adapter.initialize(this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "integrationType", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "integrationId", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "integrationPrimitiveId", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "locationPrimitiveId", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "locationId", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "priceInflation", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "priceRoundingMode", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "pickupPriceInflation", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "pickupPriceRoundingMode", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "modifierInflation", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "failureCode", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "failureReason", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "state", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "createdAt", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "updatedAt", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "defaultPrepTime", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "pickupInstructions", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { MenuConfiguration as default };